import { Box, Flex, Skeleton, Text } from '@mantine/core'
import { ReactQuery } from 'cms-api'
import Link from 'next/link'
import React from 'react'
import { ROUTE } from 'shared-constants'
import { Grid } from 'components/Layout'
import { COLOR_NAMES, FONT_STACK, FONT_WEIGHT } from 'Theme'

const GREEN = COLOR_NAMES.PINEY_LAKE
const INK = COLOR_NAMES.EEIRE_BLACK
const MUTED = COLOR_NAMES.GRAY_SHINGLE
const GOLD = '#C8993A'

const KpiCardSkeleton = () => (
  <Box
    bd={`solid 1px ${COLOR_NAMES.JUPITER}`}
    p={20}
    style={{ borderRadius: 10 }}
    bg="white"
  >
    <Skeleton height={11} width="50%" mb={14} />
    <Skeleton height={34} width="40%" />
  </Box>
)

const KpiCard = ({
  label,
  value,
  sub,
  accent,
}: {
  label: string
  value: string
  sub: string
  accent: string
}) => (
  <Link href={ROUTE.EXPERT_ORDERS()}>
    <Box
      bd={`solid 1px ${COLOR_NAMES.JUPITER}`}
      p={20}
      style={{ borderRadius: 10, height: '100%' }}
      bg="white"
    >
      <Text
        tt="uppercase"
        fz={11}
        fw={FONT_WEIGHT.SEMI_BOLD}
        lts="0.12em"
        c={MUTED}
      >
        {label}
      </Text>
      <Flex align="baseline" gap={10} mt={6}>
        <Text fz={38} ff={FONT_STACK.SERIF} fw={FONT_WEIGHT.MEDIUM} c={accent}>
          {value}
        </Text>
        <Text fz={12} c={MUTED}>
          {sub}
        </Text>
      </Flex>
    </Box>
  </Link>
)

export const HighlightsWidget = () => {
  const { data, isLoading } = ReactQuery.useGetExpertDashboardHighlights()
  const year = new Date().getFullYear()

  return (
    <Box mb={20}>
      <Flex justify="space-between" align="flex-end" mb={16}>
        <Box>
          <Text fz={26} ff={FONT_STACK.SERIF} fw={FONT_WEIGHT.MEDIUM} c={INK}>
            Orders
          </Text>
          <Text fz={13} c={MUTED}>
            Track your orders here.
          </Text>
        </Box>
        <Link href={ROUTE.EXPERT_ORDERS()}>
          <Text fz={13} fw={FONT_WEIGHT.SEMI_BOLD} c={GREEN}>
            View all →
          </Text>
        </Link>
      </Flex>

      <Grid
        gridTemplateColumns={{ MOBILE: '1fr', TABLET: 'repeat(3, 1fr)' }}
        gap={16}
      >
        {isLoading || !data ? (
          <>
            <KpiCardSkeleton />
            <KpiCardSkeleton />
            <KpiCardSkeleton />
          </>
        ) : (
          <>
            <KpiCard
              label="Total orders"
              value={`${data.totalOrders}`}
              sub="this year"
              accent={GREEN}
            />
            <KpiCard
              label="In progress"
              value={`${data.ordersInTransit}`}
              sub={`${data.ordersInTransit} active across studio`}
              accent={GOLD}
            />
            <KpiCard
              label="Delivered"
              value={`${data.ordersDelivered}`}
              sub={`across all ${year} projects`}
              accent={INK}
            />
          </>
        )}
      </Grid>
    </Box>
  )
}
